export enum SettingKey {
    default_language = 'default_language',
}
